import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import mobile from '../../components/isMobile.vue';
import lsDetail from '../../components/lsDetail.vue';
import lsDetailScript from '../../components/lsDetailScript.vue';
import bigImg from '../../components/bigImg.vue';
import QRCode from 'qrcodejs2';
import * as THREE from 'three';
let camera, scene, renderer;
let urlVideo, urlVideoTexture, chromakeyMaterial;
var video;
export default {
  name: 'new3DDetail',
  data() {
    return {
      detail: {},
      detailCode: '',
      config: {},
      listPage: 1,
      list: [],
      showModels: [false, false, false],
      showDetail: false,
      isMobile: false,
      showBigErCode: false,
      columns: [],
      showBigImg: false,
      showBigImgIndex: 0,
      limit: 20,
      fileCode: '',
      paramsData: {},
      activeIndex: '',
      handelSlide: false,
      player: '',
      showVideo: false
    };
  },
  components: {
    mobile,
    lsDetail,
    bigImg,
    lsDetailScript
  },
  methods: {
    init() {
      // video.play();
      // video.pause();
      // container = document.createElement('div');
      //这里注销后，取消左侧fps显示栏目
      // document.body.appendChild(container);
      // console.log('init')
      scene = new THREE.Scene();
      // scene.background = new THREE.Color("#88B9DD");
      // scene.background = new THREE.Color("#fff");
      // 抗锯齿技术1
      renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true,
        preserveDrawingBuffer: true,
        depth: true,
        logarithmicDepthBuffer: true
      });
      // // 抗锯齿技术2
      renderer.setPixelRatio(window.devicePixelRatio * 2); // 设置像素比例 
      if (window.innerWidth >= 1400) {
        renderer.setSize(400, 800);
      }
      if (window.innerWidth <= 500) {
        renderer.setSize(140, 280);
      }
      if (window.innerWidth > 500 && window.innerWidth < 768) {
        renderer.setSize(165, 330);
      }
      if (window.innerWidth >= 768 && window.innerWidth < 1100) {
        renderer.setSize(250, 500);
      }
      renderer.setClearColor(0xffffff, 0); // 设置背景颜色和透明度
      // 这里开启，可以清除preserveDrawingBuffer，preserveDrawingBuffer为false的时候,
      renderer.autoClear = true; // 关闭自动清除 
      renderer.gammaInput = true; // 开启gamma校正 
      renderer.gammaOutput = true;
      renderer.shadowMap.enabled = true; // 开启阴影 
      renderer.shadowMap.type = THREE.PCFSoftShadowMap; // 阴影类型 
      renderer.toneMapping = THREE.ReinhardToneMapping; // 色调映射 
      renderer.toneMappingExposure = 1.5; // 曝光度 
      renderer.toneMappingWhitePoint = 1; // 白点 

      // 3
      //       renderer.setPixelRatio(window.devicePixelRatio); 
      // renderer.setSize(window.innerWidth, window.innerHeight); 
      // renderer.setClearColor(0xffffff, 0); // 设置背景颜色和透明度 
      // renderer.autoClear = false; // 关闭自动清除 
      // renderer.gammaInput = true; // 开启gamma校正 
      // renderer.gammaOutput = true; 
      // renderer.shadowMap.enabled = true; // 开启阴影 
      // renderer.shadowMap.type = THREE.PCFSoftShadowMap; // 阴影类型 
      // renderer.toneMapping = THREE.ReinhardToneMapping; // 色调映射 
      // renderer.toneMappingExposure = 1.5; // 曝光度 
      // renderer.toneMappingWhitePoint = 1; // 白点 

      // renderer.setPixelRatio(window.devicePixelRatio);
      // renderer.setSize(window.innerWidth, window.innerHeight);

      document.body.appendChild(renderer.domElement);
      camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
      // camera = new THREE.PerspectiveCamera(85, window.innerWidth / window.innerHeight, 1, 1000);
      // controls = new OrbitControls(camera, renderer.domElement);
      // // 这里设置禁止拖拽和缩放
      // controls.enableZoom = false;
      // // to disable rotation
      // controls.enableRotate = false;
      // // to disable pan
      // controls.enablePan = false;

      // controls.minDistance = 1;
      // controls.maxDistance = 20;
      // controls.enableDamping = true;
      // controls.dampingFactor = 0.5;
      // 这里设置网格的帮助
      // gridHelper = new THREE.GridHelper(16, 9);

      // gridHelper.position.y = -1.5;
      // scene.add(gridHelper);
      // 这里设置网格的帮助
      // 这里设置所处的位置
      // z 右移 y 控制上下
      // z 为正 右移动 为负 左移动
      //  y 负值 上移动  正值  下移动
      // urlVideo
      // camera.position.set(0, 0.5, 1.5);
      // pc
      // camera.position.set(2, 0.5, 2.5);
      // app
      // x 控制左右 小 右  大 左  y 上下 小 上  大 下   z 远近
      if (window.innerWidth >= 1400) {
        camera.position.set(2, 0.5, 2.5);
      } else {
        camera.position.set(1.8, 0.2, 3.5);
      }

      // urlVideo = document.getElementById("video");
      // console.log(urlVideo)
      video.onplaying = function () {
        urlVideoTexture = new THREE.VideoTexture(video);
        urlVideoTexture.minFilter = THREE.LinearFilter;
        urlVideoTexture.magFilter = THREE.LinearFilter;
        // const vertexShader =readFile('../three.vert')
        // const fragmentShader =readFile('../three.frag')
        // Cria o material usando a urlVideoTexture
        chromakeyMaterial = new THREE.ShaderMaterial({
          transparent: true,
          uniforms: {
            map: {
              value: urlVideoTexture
            },
            keyColor: {
              value: [0.0, 1.0, 0.0]
            },
            similarity: {
              value: 0.76
            },
            smoothness: {
              value: 0.0
            }
          },
          vertexShader: `
  varying vec2 vUv;
  void main( void ) {
  vUv = uv;
  gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.5);
  }
                    `,
          fragmentShader: `
  uniform vec3 keyColor;
  uniform float similarity;
  uniform float smoothness;
  varying vec2 vUv;
  uniform sampler2D map;
  void main() {
  vec4 videoColor = texture2D(map, vUv);
  float Y1 = 0.299 * keyColor.r + 0.587 * keyColor.g + 0.114 * keyColor.b;
  float Cr1 = keyColor.r - Y1;
  float Cb1 = keyColor.b - Y1;
  float Y2 = 0.299 * videoColor.r + 0.587 * videoColor.g + 0.114 * videoColor.b;
  float Cr2 = videoColor.r - Y2;
  float Cb2 = videoColor.b - Y2;
  float blend = smoothstep(similarity, similarity + smoothness, distance(vec2(Cr2, Cb2), vec2(Cr1, Cb1)));
  gl_FragColor = vec4(videoColor.rgb, videoColor.a * blend);
  }
`
        });
        // 设置身体宽高比
        const geometry = new THREE.PlaneGeometry(9, 16);
        const mesh = new THREE.Mesh(geometry, chromakeyMaterial);
        // 这里设置身体的大小
        // pc
        // geometry.scale(1.2, 0.3, 0.3);
        // app
        // x 宽度  y高度   z 左右
        if (window.innerWidth >= 1400) {
          geometry.scale(1.2, 0.3, 0.3);
        } else {
          geometry.scale(0.6, 0.6, 0.5);
        }

        // geometry.scale(1, 1, 1);

        // geometry.scale(0.12, 0.12, 0.12);

        // x,y,z  
        // mesh.position.set(5.5, 1,0 )
        // pc
        // mesh.position.set(2, 0, 0)
        // app
        mesh.position.set(2, 0, 0);
        scene.add(mesh);
      };

      // var data = {
      //     keyColor: [0, 200, 0],
      //     similarity: 0.74,
      //     smoothness: 0.0
      // };
      // 取消右上角控制 台
      // var gui = new dat.GUI({ width: 300 });
      // gui.addColor(data, 'keyColor').onChange(() => updateKeyColor(data.keyColor));
      // gui.add(data, 'similarity', 0.0, 1.0).onChange(() => updateSimilarity(data.similarity));
      // gui.add(data, 'smoothness', 0.0, 1.0).onChange(() => updateSmoothness(data.smoothness));

      // stats = new Stats();
      // container.appendChild(stats.domElement);

      window.addEventListener('resize', this.onWindowResize, false);
      this.render();
    },
    onWindowResize() {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      // camera.position.set(0, 0.5, 1);

      // let y = 2
      // y = y - camera.aspect * 1.0
      // camera.position.set(0, 0.5, y);
      if (window.innerWidth >= 1400) {
        renderer.setSize(400, 800);
      }
      if (window.innerWidth <= 500) {
        renderer.setSize(140, 280);
      }
      if (window.innerWidth > 500 && window.innerWidth < 768) {
        renderer.setSize(165, 330);
      }
      if (window.innerWidth >= 768 && window.innerWidth < 1100) {
        renderer.setSize(250, 500);
      }
      // renderer.setSize(140, 280);
      this.render();
    },
    // animate() {
    //   requestAnimationFrame(this.animate);
    //   //if (urlVideo.readyState === urlVideo.HAVE_ENOUGH_DATA) {
    //   if (urlVideoTexture)
    //     urlVideoTexture.needsUpdate = true;
    //   //}
    //   //controls.update();
    //   //stats.update();
    //   this.render();

    // },
    render() {
      requestAnimationFrame(this.render);
      renderer.render(scene, camera);
    },
    toIndex() {
      this.$router.push({
        name: 'new3DList',
        query: {
          fid: this.$route.query.fid,
          type: this.$route.query.type || 'white'
        },
        params: this.paramsData.page ? this.paramsData : JSON.parse(window.sessionStorage.getItem("searchKey"))
      });
    },
    getDetailById(id) {
      this.$ajax(`${baseUrl}/api/micro-backend/front/mh/detail?id=${id}`).then(res => {
        this.detail.content = res.data.data.content;
      });
    },
    //获取栏目列表
    getColumn() {
      let query = {
        fid: this.$route.query.fid || '151066',
        formId: 112712,
        page: 1,
        limit: 50
      };
      this.$api.singleformList(query).then(res => {
        this.columns = res.data.map(item => {
          let nItem = {
            columnName: this.getConfigInFormData(item.formData, 'name')
          };
          return nItem;
        });
      });
    },
    clickErCode() {
      this.showBigErCode = !this.showBigErCode;
      if (!this.showBigErCode) return;
      let query = this.$route.query;
      let url = window.location.href;
      this.$nextTick(() => {
        this.$refs.erWeiMaCode.innerHTML = '';
        new QRCode(this.$refs.erWeiMaCode, {
          text: url,
          //页面地址 ,如果页面需要参数传递请注意哈希模式#
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        });
      });
    },
    clickDetail(index, m_index) {
      let target = this.list[index];
      let params = this.paramsData;
      params.index = this.list.findIndex(i => {
        return i.code == target.code;
      });
      let query = {
        fid: this.$route.query.fid,
        type: this.$route.query.type,
        code: target.code
      };
      if (target.autoCode) query.autoCode = target.autoCode;
      if (target.code == this.detailCode) query.index = m_index || 0;
      // let params = {
      //   page: parseInt(params.index/20)
      // }
      // window.sessionStorage.setItem("searchKey", JSON.stringify(params))
      this.$router.replace({
        name: 'new3DDetail',
        query,
        params
      });
    },
    // 点击左侧三个按钮
    showModel(index) {
      // if (index != 2 && this.detail.audio) this.$refs.voice.pause()
      if (index == 1) return window.open(this.detail.zhuanti);
      this.showModels = this.showModels.map((item, i) => {
        i == index ? item = !item : '';
        return item;
      });
      if (index == 2 && this.showModels[2]) {
        // 江西青铜虎在测试环境增加一个视频demo
        if (this.$route.query.fid == 200090 && this.$route.query.code == '000045') {
          this.openVideo();
          this.showVideo = true;
          return;
        }
        // this.$refs.voice.play()
      }
      if (index == 2 && !this.showModels[2]) {
        if (this.$route.query.fid == 200090 && this.$route.query.code == '000045') {
          // this.$refs.videoPlayer.pause()
          // this.player.pause()
          this.closeVideo();
          return this.showVideo = false;
        }
        // this.$refs.voice.pause()
      }
    },
    // 打开视频
    openVideo() {
      // video.pause()
      video.currentTime = 0;
      video.muted = false;
      // document.getElementById("video").src = this.detail.videoUrl
      // video.src = this.detail.videoUrl
      video.play();
      document.getElementsByTagName('canvas')[document.getElementsByTagName('canvas').length - 1].style.display = 'block';

      // let result = new Promise((resolve, reject) => {
      //   this.detail.videoUrl = `${location.origin}${location.pathname}/hu.mp4`
      //   document.getElementById("video").src = this.detail.videoUrl
      //   resolve()
      // })
      // result.then(() => {
      //   console.log('this.detail.videoUrl')
      //   console.log(this.detail.videoUrl)
      //   this.init()
      //   document.getElementsByTagName('canvas')[document.getElementsByTagName('canvas').length - 1].style.marginBottom = '100px'
      //   document.getElementsByTagName('canvas')[document.getElementsByTagName('canvas').length - 1].style.zIndex = 999
      // })

      //   new Promise(()=>{
      //     this.detail.videoUrl = `${location.origin}${location.pathname}/hu.mp4`
      //         document.getElementById("video").src= this.detail.videoUrl
      // document.getElementsByTagName('canvas')[document.getElementsByTagName('canvas').length-1].style.marginBottom='100px'
      //   }).then(()=>{
      //     console.log('12354')
      //     this.init()
      //   })

      // document.getElementById("video").src=`${location.origin}${location.pathname}/hu.mp4`
    },
    // 关闭视频
    closeVideo() {
      // video.src = null
      video.pause();
      video.currentTime = 0;
      scene = new THREE.Scene();
      console.log(this.detail.video);
    },
    setParent(type, data) {
      if (type == 1) {
        this.list.splice(4, 0, data);
        this.swiperEl.slideTo(4);
        return;
      }
      this.detail = data;
      if (this.$route.query.fid == 200090 && this.$route.query.code == '000045') {
        let result = new Promise((resolve, reject) => {
          this.detail.videoUrl = this.detail.video;
          video.src = this.detail.video;
          // video.src = `${location.origin}${location.pathname}/hu.mp4`
          video.play();
          console.log(123);
          console.log(this.detail.videoUrl);
          resolve();
        });
        result.then(() => {
          this.init();
          document.getElementsByTagName('canvas')[document.getElementsByTagName('canvas').length - 1].style.display = 'none';
        }).then(() => {
          console.log(12355);
          //     video.pause()
          // video.currentTime = 0
          // video.src  = `${location.origin}${location.pathname}/hu.mp4`
          // video.src = this.detail.videoUrl
          // video.pause();

          // this.detail.videoUrl = `${location.origin}${location.pathname}/hu.mp4`
          // this.detail.videoUrl = this.detail.video

          // console.log(this.detail.video)
          // document.getElementById("video").src = `${location.origin}${location.pathname}/hu.mp4`
          document.getElementsByTagName('canvas')[document.getElementsByTagName('canvas').length - 1].style.zIndex = 999;
          document.getElementsByTagName('canvas')[document.getElementsByTagName('canvas').length - 1].style.marginBottom = '100px';
        });
        // this.init()
      }
      // document.addEventListener("DOMContentLoaded", () => {
      // });
      // 没有fileCode的老馆，增加activeIndex的判断
      // let m_index = this.$route.query.index || 0
      // let activeIndex = this.list.findIndex((item) => {return item.code == this.detailCode && (this.fileCode ? item.autoCode == this.fileCode : item.m_index == m_index)})
      // // 当前数据不在列表中，继续获取列表
      // if (activeIndex == -1) {
      //   activeIndex = this.list.findIndex((item, index) => {return item.code == this.detail.code})
      //   this.activeIndex = activeIndex
      //   this.$nextTick(() => {
      //     this.swiperEl.slideTo(this.activeIndex)
      //     this.showDetail = true
      //   })
      // }
    },
    // 获取页面配置
    getConfig() {
      let singleform = {
        limit: 100,
        page: 1
      };
      singleform.fid = this.$route.query.fid || '151066';
      singleform.formId = '112706';
      this.$api.singleformList(singleform).then(res => {
        let data = res.data[0];
        this.config = {
          logo: this.getConfigInFormData(data.formData, 'logo', 'img'),
          title: this.getConfigInFormData(data.formData, 'title')
        };
        document.title = this.config.title || '文物综合展示系统';
        // if (this.paramsData.page && parseInt(this.paramsData.page) > 1) {
        //   // this.limit = parseInt(this.paramsData.index) < 100 ? parseInt(this.paramsData.index) + 3 : 50
        //   this.listPage = parseInt(this.paramsData.page)
        //   return this.getList() 
        // }
        this.getList();
      });
    },
    // 获取底部文物信息列表
    getList(type, limit) {
      let query = {
        deptId: this.$route.query.fid || '151066',
        formId: 113010,
        page: this.listPage,
        limit: this.limit || 20,
        searchStr: ''
      };
      let a = {
        filters: [[{
          alias: "showType",
          compt: "checklist",
          express: "match",
          range: null,
          val: ['电脑端与移动端']
        }]],
        model: 0
      };
      if (this.paramsData.page) {
        let params = this.paramsData;
        params.column && params.column != '全部' ? a.filters.push([{
          alias: "column",
          compt: "selectbox",
          express: "match",
          id: 41,
          range: null,
          val: [params.column]
        }]) : '';
        params.type ? a.filters.push([{
          alias: "type",
          compt: "selectbox",
          express: "like",
          id: 29,
          range: null,
          val: [params.type]
        }]) : '';
        params.keyword ? a.filters.push([{
          alias: "antiqueName",
          compt: "selectbox",
          express: "like",
          id: 1,
          range: null,
          val: [params.keyword]
        }]) : '';
      }
      query.searchStr = encodeURI(JSON.stringify(a));
      this.$api.singleadvanceSearch(query).then(res => {
        this.listTotal = res.totalPage;
        this.setListData(res.dataList, type);
      });
    },
    // 底部文物信息列表数据解析
    setListData(data, type) {
      let list = data.map((item, index) => {
        let nItem = {
          columnName: this.getValInFormData(item.formIdValueData, 'column'),
          name: this.getValInFormData(item.formIdValueData, 'antiqueName'),
          img: this.getValInFormData(item.formIdValueData, 'thumbnail', 'img'),
          code: this.getValInFormData(item.formIdValueData, 'autoId'),
          type: this.getValInFormData(item.formIdValueData, 'type'),
          index: index,
          m_index: 0,
          autoCode: this.getValInFormData(item.formIdValueData, 'autoCode')
        };
        return nItem;
      });
      // 手动塞重复数据的index
      list.map(item => {
        if (list.filter(l => {
          return l.code == item.code;
        }).length > 1) {
          let f_list = list.filter(l => {
            return l.code == item.code;
          });
          f_list.map((f, i) => {
            list[f.index].m_index = i;
          });
        }
      });
      if (this.$route.query.autoCode) {
        // this.listPage > 1 ? list = list.filter((l) => {
        //   return l.autoCode != this.$route.query.autoCode
        // }) : ''
      } else {
        // this.listPage > 1 ? list = list.filter((l) => {
        //   return l.code != this.detailCode
        // }) : ''
      }
      this.list = this.list.concat(list);
      let that = this;
      if (this.listPage == 1) {
        this.$nextTick(() => {
          if (!this.isMobile && !this.$route.query.hideOthers) {
            this.swiperEl = new Swiper(this.$refs.swipercontainer, {
              navigation: {
                nextEl: ".btnTurnRight",
                prevEl: ".btnTurnLeft"
              },
              direction: 'vertical',
              slidesPerView: 'auto',
              initialSlide: 0,
              centeredSlides: true,
              runCallbacksOnInit: false,
              touchMoveStopPropagation: true,
              // slideToClickedSlide: true,
              observer: true,
              observeSlideChildren: true
            });
            let that = this;
            this.swiperEl.on('slideChangeTransitionEnd', function (e) {
              that.slideFun(e);
            });
          }
        });
        if (type == 'changeColumn') {
          this.detailCode = this.list[0].code;
          this.showModels = [false, false, false];
          this.$nextTick(() => {
            this.$refs.lsDetail.slideFun(this.detail);
          });
          return;
        }
        let m_index = this.$route.query.index || 0;
        console.log(this.list, this.detailCode);
        let activeIndex = this.list.findIndex((item, index) => {
          return item.code == this.detailCode && (this.fileCode ? item.autoCode == this.fileCode : item.m_index == m_index);
        });
        console.log(activeIndex, 222);
        // 当前数据不在列表中，继续获取列表
        if (activeIndex == -1) {
          this.getActiveList();
        } else {
          this.activeIndex = activeIndex;
          this.$nextTick(() => {
            this.swiperEl ? this.swiperEl.slideTo(this.activeIndex) : '';
            this.showDetail = true;
          });
        }
      } else {
        if (this.activeIndex) return;
        let m_index = this.$route.query.index || 0;
        let activeIndex = this.list.findIndex(item => {
          return item.code == this.detailCode && (this.fileCode ? item.autoCode == this.fileCode : item.m_index == m_index);
        });
        // 当前数据不在列表中，继续获取列表
        if (activeIndex == -1) {
          this.getActiveList();
        } else {
          this.activeIndex = activeIndex;
          console.log(activeIndex, 333);
          setTimeout(() => {
            this.$nextTick(() => {
              this.swiperEl ? this.swiperEl.slideTo(this.activeIndex) : '';
              this.showDetail = true;
            });
          });
        }
      }
    },
    // 获取当前数据在第几个
    getActiveList() {
      this.listPage++;
      this.getList();
    },
    // 切换底部文物
    slideFun(e) {
      if (this.listPage < this.listTotal) {
        if ((this.swiperEl.realIndex + 1) % 10 == 0 || this.swiperEl.realIndex + 1 > 10 * (this.listPage - 1) || this.swiperEl.realIndex == this.list.length) {
          this.listPage++;
          this.getList();
        }
      }
    },
    getConfigInFormData(data, id, type) {
      let target = data.find(d => {
        return d.alias == id;
      });
      if (!target) return '';
      target = target.values[0];
      if (!target) return '';
      target.file = process.env.NODE_ENV == 'development' ? `https://museum.chaoxing.com/star3/origin/${target.objectId}.${target.suffix}` : target.fileUrl ? target.fileUrl.replace('http:', 'https:') : '';
      return type ? target.file : target.val;
    },
    getValInFormData(data, id, type) {
      if (!data[id] || !data[id].groupValues[0] || !data[id].groupValues[0].values[0].length) {
        return '';
      }
      let target;
      if (type && type == 'img') {
        if (!data[id].groupValues[0].values[0][0]) return;
        target = process.env.NODE_ENV == 'development' ? data[id].groupValues[0].values[0][0] : data[id].groupValues[0].values[0][0].fileUrl;
        target = target && process.env.NODE_ENV != 'development' ? target.replace('http:', 'https:') : `https://museum.chaoxing.com/star3/origin/${target.objectId}.${target.suffix}`;
      } else {
        target = type ? data[id].groupValues[0].values[0][0][type] : data[id].groupValues[0].values[0][0].val;
      }
      return target;
    }
  },
  mounted() {
    this.paramsData = window.sessionStorage.getItem("searchKey") ? JSON.parse(window.sessionStorage.getItem("searchKey")) : {};
    this.detailCode = this.$route.query.code;
    this.fileCode = this.$route.query.autoCode;
    this.getConfig();
    this.getColumn();
    video = document.getElementById("video");
    console.log(video + '111');
    console.log(this.detail.videoUrl);

    // this.detail.videoUrl = `${location.origin}${location.pathname}/hu.mp4`
    // this.init()
  },
  watch: {
    '$route'(to, from) {
      if (to.name == "new3DDetail") {
        location.reload();
      }
    }
  },
  created() {
    let list2 = ['img.js'];
    list2.map(item => {
      let oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      oScript.src = `js/${item}`;
      document.body.appendChild(oScript);
    });
  }
};